<nav #navbar class="navbar" [ngClass]="isNavbarShow ? 'active' : 'active'">
  <div class="container-fluid">
    <div class="navbar-header logo-bg">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <!-- mobile menu bars -->
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" [style.cursor]="'pointer'">
        <img src="../../../assets/logo-transparent.png" alt="logo" />
        <!-- <span class="logo-name">GSF</span> -->
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <ul class="float-start collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse"
            matTooltip="Toggle sidenav">
            <mat-icon>menu</mat-icon>
          </button>
        </li>
      </ul>

      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons"
            matTooltip="Switch to fullscreen">
            <mat-icon>fullscreen</mat-icon>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- Switch Account option -->
        <li class="nav-item user_profile" ngbDropdown *ngIf="type=='1'">
          <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
            <mat-icon aria-hidden="false" class="msr-2" matTooltip="Switch account">keyboard_arrow_down</mat-icon>
          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <!-- Search Bar -->
              <div class="search-bar sticky-search">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Search Client" 
                  [(ngModel)]="searchText"
                  (input)="filterClients()" #searchInput/>
              </div>
              <!-- Conditional Rendering -->
              <ng-container *ngIf="filteredClients.length > 0; else noClientsFound">
                <!-- Dropdown List -->
                <ul class="menu">
                  <li class="body">
                    <ul class="user_dw_menu">
                      <li *ngFor="let client of filteredClients; let index=index;">
                        <a href="javascript:void(0);" (click)="switchAccount(client,index)" [id]="index" 
                        [ngClass]="{ 
                          'text-info': isSelected(client),
                          'selectedClientDropDown': isSelected(client)
                        }">
                          <mat-icon aria-hidden="false" class="msr-2">person</mat-icon>{{client.organization_name}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </ng-container>

              <!-- No Clients Found Template -->
              <ng-template #noClientsFound>
                <div class="no-clients-message text-center mt-3">
                  No Client Found
                </div>
              </ng-template>
            </div>
          </div>
        </li>
        <!-- #END# Switch Account option -->

        <!-- #START# Notifications-->

        <!-- #END# Notifications-->
        <li class="nav-item user_profile" ngbDropdown>
          <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">

            <div class=" image  bg-dark text-center rounded-circle">
              <div style="height: 30px;width: 30px; padding-left: 1px; padding-top: 5px;" class="text-white"
                matTooltip="Account menu">
                {{userName}}
              </div>
            </div>

          </a>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <li>
                      <a [routerLink]="['/profile/user-profile']" onClick="return false;">
                        <mat-icon aria-hidden="false" class="msr-2">person</mat-icon>Profile
                      </a>
                    </li>
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="msr-2">feedback</mat-icon>Feedback
                      </a>
                    </li> -->
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <mat-icon aria-hidden="false" class="msr-2">help</mat-icon>Help
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()">
                        <mat-icon aria-hidden="false" class="msr-2">power_settings_new</mat-icon>Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
        <li class="float-end">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons" matTooltip="Settings">
            <mat-icon id="settingBtn">settings</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
